import { Box, Link } from '@mui/material'
import CompliancePlip from '../../../../components/CompliancePlip'
import { ComplianceStatus } from '../../../../types'
import useCustomer from '../../../../hooks/useCustomer'

interface MedicationsProps {
  link: string
}

const Medications = ({ link }: MedicationsProps) => {
  const customer = useCustomer()
  const metadata = customer.customerMetadata

  return metadata && (
    <Box>
      <div className='border-box'>
        <div>
          <CompliancePlip message='' className='dashboard-compliance' status={metadata.medication_status ?? ComplianceStatus.Inactive} />
        </div>
        <div className='compliance-message'>
          <p className='card-info'>{metadata.kit_message_long}</p>
          <Link className='small-text' href={link}>{metadata.medication_status === ComplianceStatus.Inactive ? 'Learn More' : 'View Details'}</Link>
        </div>
      </div>
      <div className='card-footer flex justify-between'>
        {metadata.active_med_kits > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{metadata.active_med_kits}</span>
            <span className="text-base">
              <CompliancePlip message='' className='dashboard-compliance small' status={metadata.medication_status ?? ComplianceStatus.Inactive} />
              Kit{metadata.active_med_kits > 1 ? 's' : ''}
            </span>
          </div>
        )}
      </div>
    </Box>
  )
}

export default Medications